import axios from '../axios';

/**
 * 获取个人信息
 * 
 * @url /auth/me
 * 
 */

export function personalInformation(params) {
    return axios.post('/auth/me', params)
}
/**
 * 我绑定的企业
 * 
 * @url /bind/index
 * 
 */

export function boundEnterprise(params) {
    return axios.post('/bind/index', params)
}

/**
 * 切换默认企业
 * 
 * @url /bind/change
 * 
 */

export function boundchange(params) {
    return axios.post('/bind/change', params)
}
/**
 * 企业认证
 * 
 * @url /user/user_apply
 * 
 */

export function userapply(params) {
    return axios.post('/user/user_apply', params)
}
/**
 * 我的企业认证申请
 * 
 * @url /user/my_apply
 * 
 */

export function usermyapply(params) {
    return axios.post('/user/my_apply', params)
}
/**
 * 取消企业认证申请
 * 
 * @url /user/remove_apply
 * 
 */

export function userremoveapply(params) {
    return axios.post('/user/remove_apply', params)
}
// 绑定企业关键字提示
/**
 * 
 * @url /company/search
 * 
 */

export function companysearch(params) {
    return axios.post('/company/search', params)
}
/**
 * 根据手机号查询用户
 * 
 * @url /auth/search
 * 
 */

export function authSearch(params) {
    return axios.post('/auth/search', params)
}
/**
 * 分页获取项目-设计中心
 * 
 * @url /ent_design/index
 * 
 */

export function developmentIndex(params) {
    return axios.post('/ent_design/index', params)
}
/**
 * 获取项目修改-设计中心
 * 
 * @url /ent_design/detail
 * 
 */

export function designDetail(params) {
    return axios.post('/ent_design/update', params)
}
/**
 * 获取自己的项目详情-设计中心
 * 
 * @url /ent_design/detail
 * 
 */

export function Projectdetails(params) {
    return axios.post('/ent_design/detail', params)
}
/**
 * 项目添加-设计中心
 * 
 * @url /ent_design/save
 * 
 */

export function designSave(params) {
    return axios.post('/ent_design/save', params)
}
/**
 * 项目删除-设计中心
 * 
 * @url /ent_design/delete
 * 
 */

export function designDelete(params) {
    return axios.post('/ent_design/delete', params)
}
/**
 *添加人员-设计中心
 * 
 * @url /ent_design/add_project_user
 * 
 */

export function pipoSearch(params) {
    return axios.post('/ent_design/add_project_user', params)
}
/**
 *人员清单-设计中心
 * 
 * @url /ent_design/user_list
 * 
 */

export function pipoList(params) {
    return axios.post('/ent_design/user_list', params)
}
/**
 *移出项目人员-设计中心
 * 
 * @url /ent_design/remove_project_user
 * 
 */

export function outpipo(params) {
    return axios.post('/ent_design/remove_project_user', params)
}
/**
 *企业消息
 * 
 * @url /message/company
 * 
 */

export function messagecompany(params) {
    return axios.post('/message/company', params)
}
/**
 *个人消息
 * 
 * @url /message/person
 * 
 */

export function messageperson(params) {
    return axios.post('/message/person', params)
}
/**
 *设为已读
 * 
 * @url /message/read
 * 
 */

export function messageread(params) {
    return axios.post('/message/read', params)
}
/**
 *删除提醒
 * 
 * @url /message/del
 * 
 */

export function messagedel(params) {
    return axios.post('/message/del', params)
}
/**
 *更新个人资料
 * 
 * @url /auth/profile
 * 
 */

export function authprofile(params) {
    return axios.post('/auth/profile', params)
}
/**
 *订单
 * 
 * @url /company/orders
 * 
 */

export function companyorders(params) {
    return axios.post('/company/orders', params)
}
/**
 *个人中心数据统计
 * 
 * @url /index/dashboard
 * 
 */

export function indexdashboard(params) {
    return axios.post('/index/dashboard', params)
}
